var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoatHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 36,
    viewBox: "0 0 93 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29_613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.683968 17.1751C0.563968 17.3551 0.548968 17.5951 0.623968 17.7901L8.33397 35.4751C8.49897 35.7451 8.84397 35.8651 9.14397 35.7301C9.47397 35.5951 9.62397 35.2051 9.47397 34.8751L2.19897 18.1801H12.009L13.854 22.8151C13.944 23.0551 14.184 23.2201 14.454 23.2201H68.364C68.364 23.2201 68.469 23.2051 68.544 23.1751C68.574 23.1751 68.604 23.1451 68.634 23.1301C68.664 23.1151 68.709 23.0851 68.754 23.0551L68.829 22.9951C68.829 22.9951 68.904 22.9051 68.934 22.8451L70.764 18.9301H91.194L84.639 35.1151C84.504 35.4451 84.669 35.8201 84.999 35.9551C85.344 36.0901 85.704 35.9251 85.839 35.5951L92.754 18.5251C92.829 18.3301 92.814 18.1051 92.694 17.9251C92.574 17.7451 92.379 17.6401 92.154 17.6401H88.419V13.1401C88.419 12.7801 88.134 12.4951 87.774 12.4951H84.069V7.99506C84.069 7.63506 83.784 7.35006 83.424 7.35006H66.009C65.649 7.35006 65.364 7.63506 65.364 7.99506V12.4951H61.659C61.299 12.4951 61.014 12.7801 61.014 13.1401V21.9151H26.844V10.7851H28.494C28.854 10.7851 29.139 10.5001 29.139 10.1401C29.139 9.78006 28.854 9.49506 28.494 9.49506H19.914V2.16006H21.174C21.534 2.16006 21.819 1.87506 21.819 1.51506C21.819 1.15506 21.534 0.870056 21.174 0.870056H8.03397C7.67397 0.870056 7.38897 1.15506 7.38897 1.51506V16.8901H1.22397C0.998968 16.8901 0.803968 16.9951 0.683968 17.1751ZM67.914 21.9301H62.274V18.9301H69.309L67.914 21.9301ZM78.384 17.6401H70.974V13.7851H78.384V17.6401ZM87.099 13.8001V17.6551H79.689V13.8001H87.099ZM75.324 8.65506H82.734V12.5101H75.324V8.65506ZM66.624 8.65506H74.034V12.5101H66.624V8.65506ZM62.259 13.8001H69.669V17.6401H62.259V13.8001ZM8.67897 2.16006H18.594V9.51006H8.67897V2.16006ZM8.66397 10.8001H25.509V21.9301H14.889L13.044 17.2951C12.954 17.0551 12.714 16.8901 12.444 16.8901H8.66397V10.8001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7455 13.8001V17.6551H53.3355V13.8001H60.7455ZM62.0205 12.5251H52.0605V18.9301H62.0205V12.5251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7455 18.9301V21.9301H53.3355V18.9301H60.7455ZM62.0205 17.6551H52.0605V23.2051H62.0205V17.6551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0287 13.8001V17.6551H44.6188V13.8001H52.0287ZM53.3038 12.5251H43.3438V18.9301H53.3038V12.5251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3491 8.65513V12.5101H57.9391V8.65513H65.3491ZM66.6241 7.38013H56.6641V13.7851H66.6241V7.38013Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5893 8.65513V12.5101H49.1793V8.65513H56.5893ZM57.8643 7.38013H47.9043V13.7851H57.8643V7.38013Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0287 18.9301V21.9301H44.6188V18.9301H52.0287ZM53.3038 17.6551H43.3438V23.2051H53.3038V17.6551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3149 13.8001V17.6551H35.9049V13.8001H43.3149ZM44.5899 12.5251H34.6299V18.9301H44.5899V12.5251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8745 8.65513V12.5101H40.4645V8.65513H47.8745ZM49.1495 7.38013H39.1895V13.7851H49.1495V7.38013Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3149 18.9301V21.9301H35.9049V18.9301H43.3149ZM44.5899 17.6551H34.6299V23.2051H44.5899V17.6551Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_613"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92.19,
    height: 35.13,
    fill: "white",
    transform: "translate(0.580078 0.870056)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoatHome);
export default __webpack_public_path__ + "static/media/boat_home.7886d1abd52e44988eef2a7b0f71ae52.svg";
export { ForwardRef as ReactComponent };